
const getKeyByPath = (path, name) => name === undefined ?
`${path.slice(1).toUpperCase()}_ADV_FILTERS` :
`${path.slice(1).toUpperCase()}_${name.toUpperCase()}_ADV_FILTERS`;

const init = (path) => {
  const initValue = {
    FILTER_COMPLEMENT: {},
    SELECTED_VALUES: {}
  };
  localStorage.setItem(path, JSON.stringify(initValue));
  return initValue;
};

const setLocalStorage = (path, value) => {
  localStorage.setItem(path, JSON.stringify(value));
};

const getLocalStorage = (path) => {
  // check if exist else init
  const value = localStorage.getItem(path);
  if (value) {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed;
      }
    } catch (e) {
      // fall through to re-init on corrupt/stale JSON so we don't require a manual clear
    }
  }
  return init(path);
};

export {
  getKeyByPath,
  setLocalStorage,
  getLocalStorage };